module.exports = __webpack_public_path__ + "static/media/bookingLoader.032bf6d9.gif";